var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      ref: "MemberDetials",
      staticStyle: {
        height: "calc(100vh - 150px)",
        overflow: "scroll",
        "padding-top": "20px"
      },
      attrs: { fluid: "" }
    },
    [
      _c(
        "div",
        [
          _c(
            "v-breadcrumbs",
            [
              _c(
                "v-icon",
                {
                  attrs: { slot: "divider", color: "#68718e" },
                  slot: "divider"
                },
                [_vm._v("play_arrow")]
              ),
              _vm._v(" "),
              _c("v-breadcrumbs-item", [
                _c("a", { on: { click: _vm.goBack } }, [
                  _c("span", { staticStyle: { color: "#515a75" } }, [
                    _vm._v(" Clubs")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("v-breadcrumbs-item", [
                _c("span", { staticStyle: { color: "#515a75" } }, [
                  _vm._v(_vm._s(_vm.club_details.club_name))
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "400" },
          on: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
              ) {
                return null
              }
              return _vm.cancelUpload($event)
            }
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "headline p-10 elc-clubdetails-dialog-header",
                  attrs: { "primary-title": "" }
                },
                [_vm._v("Import Member\n            ")]
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "p-10" },
                [
                  _c("div", { staticClass: "p-t-10 p-b-10" }, [
                    _c("p", { staticStyle: { color: "#5d5d5d" } }, [
                      _vm._v("Follow this Format in csv/xls/xlsx file.")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticStyle: { color: "#5d5d5d" } }, [
                      _c("strong", [_vm._v("Columns")]),
                      _vm._v(
                        " [ Name (prefix fname mname lname) , Primary\n                        Mobile,\n                        Secondary Mobile, Email, DOB (DD/MM/YYYY), Election Card ID ]\n                    "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "text-xs-center", attrs: { xs12: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Select File",
                          "prepend-icon": "attach_file"
                        },
                        on: { click: _vm.pickFile },
                        model: {
                          value: _vm.memberFileName,
                          callback: function($$v) {
                            _vm.memberFileName = $$v
                          },
                          expression: "memberFileName"
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        ref: "image",
                        staticStyle: { display: "none" },
                        attrs: {
                          type: "file",
                          id: "fileId",
                          accept:
                            ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        },
                        on: { change: _vm.onFilePicked }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticStyle: { "text-decoration": "none" },
                      attrs: {
                        href: "../../../static/assets/files/member.csv",
                        download: ""
                      }
                    },
                    [_vm._v("click\n                    here")]
                  ),
                  _vm._v(
                    " to download format of\n                file.\n\n            "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "p-10 text-sm-right" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius",
                      on: { click: _vm.cancelUpload }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius-color",
                      attrs: { disabled: _vm.uploadBtnFlag },
                      on: { click: _vm.uploadMember }
                    },
                    [_vm._v("Upload\n                ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.delDialog,
            callback: function($$v) {
              _vm.delDialog = $$v
            },
            expression: "delDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", [
                _vm._v("Are you sure you want to delete this member?")
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.delDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius-color",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.deleteMember()
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.delReqDialog,
            callback: function($$v) {
              _vm.delReqDialog = $$v
            },
            expression: "delReqDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", [
                _vm._v("Are you sure you want to delete this member?")
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.delReqDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius-color",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.deleteMemberRequest()
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "m-b-10" },
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _c(
              "span",
              { staticStyle: { "font-size": "22px", color: "#596363" } },
              [_vm._v(_vm._s(_vm.club_details.club_name))]
            )
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { staticClass: "p-10", attrs: { xs6: "", sm3: "" } },
                    [
                      _c("div", { staticClass: "float-left elc-member-card" }, [
                        _c("label", [_vm._v("Club Type")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.constant.elc_type_const[
                                _vm.club_details.elc_type
                              ]
                            )
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "p-10", attrs: { xs6: "", sm3: "" } },
                    [
                      _c("div", { staticClass: "float-left elc-member-card" }, [
                        _c("label", [_vm._v("Taluka")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.club_details.taluka))])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "p-10", attrs: { xs6: "", sm3: "" } },
                    [
                      _c("div", { staticClass: "float-left elc-member-card" }, [
                        _c("label", [_vm._v("Nodal Officer")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.club_details.officer_Data["0"].name)
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.club_details.officer_Data["0"].phone) +
                              ")"
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { staticClass: "p-10", attrs: { xs6: "", sm3: "" } },
                    [
                      _c("div", { staticClass: "float-left elc-member-card" }, [
                        _c("label", [_vm._v("Election Code")]),
                        _vm._v(" "),
                        _vm.club_details.elc_code
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.club_details.elc_code))
                            ])
                          : _c(
                              "span",
                              { staticStyle: { "text-align": "center" } },
                              [_vm._v(" -")]
                            )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.club_details.nodal_officer_id == _vm.user.officer_id ||
      _vm.user.officer_role === 5
        ? _c(
            "v-card",
            [
              _c(
                "v-tabs",
                { staticClass: "elc-tabs", attrs: { "fixed-tabs": "" } },
                [
                  _c("v-tab", [_vm._v(" Members")]),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "p-16" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs12: "", md7: "" } }),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "search",
                                      label: "Search",
                                      "single-line": "",
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.search,
                                      callback: function($$v) {
                                        _vm.search = $$v
                                      },
                                      expression: "search"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-right",
                                  attrs: { xs12: "", md2: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "elc-button-radius-color",
                                          on: { click: _vm.importMember }
                                        },
                                        [_vm._v("Import")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-tooltip",
                                        { attrs: { bottom: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "elc-button-rounded",
                                              attrs: {
                                                slot: "activator",
                                                fab: ""
                                              },
                                              on: {
                                                click:
                                                  _vm.redirectToAddNewMember
                                              },
                                              slot: "activator"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { dark: "" } },
                                                [_vm._v("add")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("Add Member")])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-data-table",
                        {
                          staticClass: "elc-deta-table fixed-header4",
                          attrs: {
                            headers: _vm.headers,
                            items: _vm.memberDetails,
                            loading: _vm.loading,
                            search: _vm.search,
                            "hide-actions": "",
                            "disable-initial-sort": true,
                            "no-data-text": _vm.loading
                              ? ""
                              : "No members available"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "elc-capital",
                                      staticStyle: {
                                        cursor: "pointer !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.openDetailDialog(props.item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(props.item.name) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  props.item.election_id != null
                                    ? _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.openDetailDialog(props.item)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(props.item.election_id) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    : _c("td", [_vm._v("-")]),
                                  _vm._v(" "),
                                  props.item.email != null
                                    ? _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.openDetailDialog(props.item)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(props.item.email) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    : _c("td", [_vm._v("-")]),
                                  _vm._v(" "),
                                  props.item.dob != 0
                                    ? _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.openDetailDialog(props.item)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(props.item.dob) +
                                              "\n\n                        "
                                          )
                                        ]
                                      )
                                    : _c("td", [_vm._v("-")]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        cursor: "pointer !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.openDetailDialog(props.item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(props.item.phone[0].phone) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  props.item.phone.length == 2
                                    ? _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.openDetailDialog(props.item)
                                            }
                                          }
                                        },
                                        [
                                          props.item.phone[1].phone != ""
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    props.item.phone[1].phone
                                                  )
                                                )
                                              ])
                                            : _c("span", [_vm._v("-")])
                                        ]
                                      )
                                    : _c("td", [_vm._v("-")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    props.item.connectly_id == null
                                      ? _c("span", [_vm._v("No")])
                                      : _c("span", [_vm._v("Yes")])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            transition: "slide-x-transition",
                                            bottom: "",
                                            right: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                slot: "activator",
                                                icon: ""
                                              },
                                              slot: "activator"
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("more_horiz")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-list-tile",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openEditDialog(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                                            Edit\n                                        "
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openDelDialog(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                                            Delete\n                                        "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: {
                                slot: "no-results",
                                value: true,
                                color: "error",
                                icon: "warning"
                              },
                              slot: "no-results"
                            },
                            [
                              _vm._v(
                                '\n                        Your search for "' +
                                  _vm._s(_vm.search) +
                                  '" found no results.\n                    '
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.totalCount > _vm.count
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "text-xs-center pt-2",
                                staticStyle: {
                                  position: "fixed",
                                  bottom: "50px",
                                  width: "96vw",
                                  "background-color": "#f7fafc"
                                }
                              },
                              [
                                _c("v-pagination", {
                                  attrs: {
                                    color: "#515a75",
                                    circle: "",
                                    "total-visible": 7,
                                    length: _vm.totalPage
                                  },
                                  on: { input: _vm.pagination },
                                  model: {
                                    value: _vm.page,
                                    callback: function($$v) {
                                      _vm.page = $$v
                                    },
                                    expression: "page"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab",
                    [
                      _vm._v(
                        "\n                Member joining request\n                "
                      ),
                      _vm.totalMemberReqCount != 0
                        ? [
                            _c(
                              "v-badge",
                              {
                                staticStyle: {
                                  margin: "0px 0px 40px 0px !important"
                                },
                                attrs: { right: "", color: "red" }
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { slot: "badge" }, slot: "badge" },
                                  [_vm._v(_vm._s(_vm.totalMemberReqCount))]
                                )
                              ]
                            )
                          ]
                        : void 0
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "p-16" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-flex", { attrs: { xs12: "", md9: "" } }),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md3: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      "append-icon": "search",
                                      label: "Search",
                                      "single-line": "",
                                      "hide-details": ""
                                    },
                                    model: {
                                      value: _vm.searchReq,
                                      callback: function($$v) {
                                        _vm.searchReq = $$v
                                      },
                                      expression: "searchReq"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-data-table",
                        {
                          staticClass: "elc-deta-table fixed-header4",
                          attrs: {
                            headers: _vm.headersJoinReq,
                            items: _vm.memberRequest,
                            loading: _vm.loading,
                            search: _vm.searchReq,
                            "hide-actions": "",
                            "disable-initial-sort": true,
                            "no-data-text": _vm.loading
                              ? ""
                              : "No members available"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "items",
                              fn: function(props) {
                                return [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "elc-capital",
                                      staticStyle: {
                                        cursor: "pointer !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.openDetailDialog(props.item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(props.item.name) +
                                          "\n\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  props.item.election_id != null
                                    ? _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.openDetailDialog(props.item)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(props.item.election_id) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    : _c("td", [_vm._v("-")]),
                                  _vm._v(" "),
                                  props.item.dob != 0
                                    ? _c(
                                        "td",
                                        {
                                          staticStyle: {
                                            cursor: "pointer !important"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.openDetailDialog(props.item)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(props.item.dob) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    : _c("td", [_vm._v("-")]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      staticStyle: {
                                        cursor: "pointer !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.openDetailDialog(props.item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(props.item.phone[0].phone) +
                                          "\n\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            transition: "slide-x-transition",
                                            bottom: "",
                                            right: ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                slot: "activator",
                                                icon: ""
                                              },
                                              slot: "activator"
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("more_horiz")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            [
                                              _c(
                                                "v-list-tile",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openRequestDialog(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                                            Verify Member\n                                        "
                                                    )
                                                  ])
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-tile",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openDelReqDialog(
                                                        props.item
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-list-tile-title", [
                                                    _vm._v(
                                                      "\n                                            Delete\n                                        "
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c(
                            "v-alert",
                            {
                              attrs: {
                                slot: "no-results",
                                value: true,
                                color: "error",
                                icon: "warning"
                              },
                              slot: "no-results"
                            },
                            [
                              _vm._v(
                                '\n                        Your search for "' +
                                  _vm._s(_vm.search) +
                                  '" found no results.\n                    '
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.totalMemberReqCount > _vm.pagiReqCount
                        ? [
                            _c(
                              "div",
                              {
                                staticClass: "text-xs-center pt-2",
                                staticStyle: {
                                  position: "fixed",
                                  bottom: "50px",
                                  width: "96vw"
                                }
                              },
                              [
                                _c("v-pagination", {
                                  attrs: {
                                    color: "#515a75",
                                    circle: "",
                                    "total-visible": 7,
                                    length: _vm.totalReqPage
                                  },
                                  on: {
                                    input: function($event) {
                                      _vm.pagination("JoinReq")
                                    }
                                  },
                                  model: {
                                    value: _vm.reqPage,
                                    callback: function($$v) {
                                      _vm.reqPage = $$v
                                    },
                                    expression: "reqPage"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "p-16" },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "", md9: "" } }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "500",
                              "font-size": "22px",
                              color: "#596363"
                            }
                          },
                          [_vm._v("Members")]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md3: "" } },
                        [
                          _c("v-text-field", {
                            staticStyle: { padding: "0", margin: "0" },
                            attrs: {
                              "append-icon": "search",
                              label: "Search",
                              "single-line": "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.search,
                              callback: function($$v) {
                                _vm.search = $$v
                              },
                              expression: "search"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  staticClass: "elc-deta-table fixed-header2",
                  attrs: {
                    headers: _vm.headersView,
                    items: _vm.memberDetails,
                    loading: _vm.loading,
                    search: _vm.search,
                    "hide-actions": "",
                    "disable-initial-sort": true,
                    "no-data-text": _vm.loading ? "" : "No members available"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c(
                            "td",
                            {
                              staticClass: "elc-capital",
                              staticStyle: { cursor: "pointer !important" },
                              on: {
                                click: function($event) {
                                  _vm.openDetailDialog(props.item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(props.item.name) +
                                  "\n\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          props.item.election_id != null
                            ? _c(
                                "td",
                                {
                                  staticStyle: { cursor: "pointer !important" },
                                  on: {
                                    click: function($event) {
                                      _vm.openDetailDialog(props.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(props.item.election_id) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _c("td", [_vm._v("-")]),
                          _vm._v(" "),
                          props.item.email != null
                            ? _c(
                                "td",
                                {
                                  staticStyle: { cursor: "pointer !important" },
                                  on: {
                                    click: function($event) {
                                      _vm.openDetailDialog(props.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(props.item.email) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _c("td", [_vm._v("-")]),
                          _vm._v(" "),
                          props.item.dob != 0
                            ? _c(
                                "td",
                                {
                                  staticStyle: { cursor: "pointer !important" },
                                  on: {
                                    click: function($event) {
                                      _vm.openDetailDialog(props.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(props.item.dob) +
                                      "\n\n                "
                                  )
                                ]
                              )
                            : _c("td", [_vm._v("-")]),
                          _vm._v(" "),
                          _c(
                            "td",
                            {
                              staticStyle: { cursor: "pointer !important" },
                              on: {
                                click: function($event) {
                                  _vm.openDetailDialog(props.item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(props.item.phone[0].phone) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          props.item.phone.length == 2
                            ? _c(
                                "td",
                                {
                                  staticStyle: { cursor: "pointer !important" },
                                  on: {
                                    click: function($event) {
                                      _vm.openDetailDialog(props.item)
                                    }
                                  }
                                },
                                [
                                  props.item.phone[1].phone != ""
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(props.item.phone[1].phone)
                                        )
                                      ])
                                    : _c("span", [_vm._v("-")])
                                ]
                              )
                            : _c("td", [_vm._v("-")]),
                          _vm._v(" "),
                          _c("td", [
                            props.item.connectly_id == null
                              ? _c("span", [_vm._v("No")])
                              : _c("span", [_vm._v("Yes")])
                          ])
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        slot: "no-results",
                        value: true,
                        color: "error",
                        icon: "warning"
                      },
                      slot: "no-results"
                    },
                    [
                      _vm._v(
                        '\n                Your search for "' +
                          _vm._s(_vm.search) +
                          '" found no results.\n            '
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.totalCount > _vm.count
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "text-xs-center pt-2",
                        staticStyle: {
                          position: "fixed",
                          bottom: "50px",
                          width: "96vw"
                        }
                      },
                      [
                        _c("v-pagination", {
                          attrs: {
                            color: "#515a75",
                            circle: "",
                            "total-visible": 7,
                            length: _vm.totalPage
                          },
                          on: { input: _vm.pagination },
                          model: {
                            value: _vm.page,
                            callback: function($$v) {
                              _vm.page = $$v
                            },
                            expression: "page"
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          ),
      _vm._v(" "),
      _vm.editFlag
        ? _c(
            "div",
            [
              _c("add-member", {
                attrs: {
                  editObj: _vm.editMember,
                  memberDialog: _vm.addMemberDialog,
                  addEditFlag: _vm.addEditFlag,
                  reqFlag: _vm.requestFlag
                },
                on: {
                  closeMemberDialog: _vm.cancelMemberDialog,
                  updateMember: _vm.updateMember
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.detailFlag
        ? _c(
            "div",
            [
              _c("member-detail-dialog", {
                attrs: {
                  editObj: _vm.editMember,
                  memberDialog: _vm.addMemberDialog,
                  detailFlag: _vm.detailFlag
                },
                on: { closeMemberDialog: _vm.cancelMemberDialog }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.addFlag
        ? _c(
            "div",
            [
              _c("add-member", {
                attrs: {
                  memberDialog: _vm.addMemberDialog,
                  addEditFlag: _vm.addEditFlag
                },
                on: {
                  closeMemberDialog: _vm.cancelMemberDialog,
                  saveMember: _vm.saveMember
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("alert-modal", {
        attrs: { alertMsg: _vm.msg, alertMsgDialog: _vm.alertDialog },
        on: {
          closeAlert: function($event) {
            _vm.alertDialog = false
          }
        }
      }),
      _vm._v(" "),
      _vm.uploadProgressPopup ? _c("progress-dialog") : _vm._e(),
      _vm._v(" "),
      _vm.uploadStatusPopup
        ? _c("upload-status-dialog", {
            attrs: {
              successArr: _vm.successRecordArr,
              failArr: _vm.failRecordArr
            },
            on: {
              closeDialog: function($event) {
                _vm.uploadStatusPopup = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25b71bba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25b71bba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/MemberDetails.vue
// module id = null
// module chunks = 